import { Divider, ListItemButton, ListItemIcon, Typography, useTheme } from '@mui/material'

import { CircleDownIcon, CircleUpIcon } from 'src/assets/icons'
import { MediaImageRender } from 'src/components/media-input/media-image-render.component'
import { GridItemCollapse } from './item-collapse.component'
import { useToggle } from 'src/hooks'
import { IMediaListItem } from 'src/types'

import { useStyles } from './styles'
import { ChevronUpIcon } from 'src/assets/icons/v2/ChevronUpIcon'
import { ChevronDownIcon } from 'src/assets/icons/v2/ChevronDownIcon'

interface IProps {
  item: IMediaListItem
}

export const GridItem = ({ item }: IProps) => {
  const theme = useTheme()
  const classes = useStyles()
  const [toggle, handleCollapse] = useToggle()

  return (
    <>
      <ListItemButton disableGutters className={classes.listItem} onClick={() => handleCollapse()}>
        <ListItemIcon>
          {toggle ? (
            <ChevronUpIcon size={28} color={theme.palette.custom.darkBlue2} />
          ) : (
            <ChevronDownIcon size={28} color={theme.palette.custom.darkBlue2} />
          )}
        </ListItemIcon>
        <div className={classes.innerItem}>
          <MediaImageRender
            type={item.type}
            link={item.link_medium || item.link}
            alt={item.title}
            className={classes.image}
          />
          <Typography className={classes.itemText}>{item.title}</Typography>
        </div>
      </ListItemButton>
      <GridItemCollapse item={item} open={toggle} />
      <Divider />
    </>
  )
}
